import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let procedure = useDataValue({
    context: 'procedure',
    viewPath: props.viewPath,
  })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => procedure, [])
}
